import React, { ChangeEventHandler, MutableRefObject } from 'react';

import { uploadFile } from '../../utils/Amplify';

type FileUploaderProps = {
  inputRef?: React.LegacyRef<HTMLInputElement>;
  setLoading?: (loading: boolean) => void;
  onUploadFinish: (url: string, fileType: string) => void;
  onFileTypeChange?: (fileType: string) => void;
  accept?: string;
  uploadProgressCallback?: (progress: any) => void;
  uploadOperationRef?: MutableRefObject<any>;
};

const FileUploader = ({
  accept,
  onUploadFinish,
  setLoading,
  inputRef,
  onFileTypeChange,
  uploadProgressCallback,
  uploadOperationRef,
}: FileUploaderProps) => {
  const onFileChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    void (async () => {
      const file: File = event.target.files[0];
      if (!file) return;
      setLoading?.(true);
      onFileTypeChange?.(file.type);
      const url = await uploadFile(file, uploadProgressCallback, uploadOperationRef);
      if (url) {
        onUploadFinish(url, file.type);
      }
      setLoading?.(false);
    })();
  };

  return <input type="file" onChange={onFileChange} hidden ref={inputRef} accept={accept} />;
};

export default FileUploader;
